function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { AllhomesGlobalContextProvider } from './provider';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var withAllhomesProvider = contextFactory => (WrappedComponent, defaultProps) => {
  var hoc = props => ___EmotionJSX(AllhomesGlobalContextProvider, _extends({}, props, {
    contextFactory: contextFactory
  }), ___EmotionJSX(WrappedComponent, _extends({}, defaultProps, props)));
  setHOCDisplayName(hoc, WrappedComponent, 'allhomesContextProvider');
  return hoistNonReactStatics(hoc, WrappedComponent);
};